module.exports = __webpack_public_path__ + "img/cloud.57638106.svg";